import React, { useState } from 'react';
import {
  Card,
  CardContent
} from '@one-thd/sui-atomic-components';
import {
  AuthorizeCard, Catalog, GiftCard, Mailbox, Secure
} from '@one-thd/sui-icons';
import PropTypes from 'prop-types';
import {
  BRUSHING_SCAMS_TITLE,
  COMMON_SCAM_TITLE,
  GIFT_CARD_TITLE,
  PAYMENT_FRAUD_TITLE
} from '../constants/Constants';

export default function FraudCards({ setSelectedText }) {
  const [currentSelection, setCurrentSelection] = useState(COMMON_SCAM_TITLE);
  const typesOfFraud = [
    { title: COMMON_SCAM_TITLE, icon: <Catalog /> },
    { title: PAYMENT_FRAUD_TITLE, icon: <AuthorizeCard /> },
    { title: GIFT_CARD_TITLE, icon: <GiftCard /> },
    { title: BRUSHING_SCAMS_TITLE, icon: <Mailbox /> },
  ];

  function determineText(title) {
    if (title === GIFT_CARD_TITLE) {
      return window.open('https://www.homedepot.com/c/gift_card_scams', '_blank');
    }
    setCurrentSelection(title);
    return setSelectedText(title);
  }

  function isActive(value) {
    return currentSelection === value;
  }

  return (
    <div>
      <div className="sui-grid sui-grid-cols-1 sui-gap-3">

        {Object.entries(typesOfFraud).map(([key, value]) => (
          <div
            className={`${isActive(value.title)
              ? 'sui-border-black sui-border-2 sui-border-solid sui-rounded-base sui-rounded-md'
              : 'sui-border-transparent sui-border-2 sui-border-solid sui-rounded-base sui-rounded-md'}`}
            key={key}
          >
            <Card
              orientation="horizontal"
              key={key}
              disableGutters
              disablePadding
              tag="button"
              onClick={() => {
                determineText(value.title);
              }}
            >
              <CardContent className="sui-p-4 sui-my-auto">
                {value.icon}
              </CardContent>
              <CardContent className="sui-my-auto">
                {value.title}
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
}

FraudCards.propTypes = {
  setSelectedText: PropTypes.func.isRequired,
};
